module.exports = __webpack_public_path__ + "img/ef69f21.png";